import {
  Button, Link, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay,
  Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr,
} from '@chakra-ui/react';
import { FiExternalLink } from 'react-icons/fi';
import { Tag } from './ui';

/** Bancos › Tarjeta de crédito: plataformas que se pagan con la tarjeta. Solo informativa (lista fija de la API). */
export default function CardPlatformsModal({ isOpen, onClose, platforms }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="4xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Text fontSize="xl" fontWeight="600">Plataformas que se pagan con la tarjeta ···{platforms.last4}</Text>
          <Text fontSize="sm" color="gray.500" fontWeight="400">Servicios que Klazia paga con esta tarjeta, con su portal y la cuenta con que se entra.</Text>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody px={0}>
          <TableContainer>
            <Table size="sm">
              <Thead>
                <Tr>
                  <Th bg="gray.50" pl={6}>Plataforma</Th>
                  <Th bg="gray.50">Para qué se usa</Th>
                  <Th bg="gray.50" pr={6}>Acceso</Th>
                </Tr>
              </Thead>
              <Tbody>
                {platforms.items.map((p) => (
                  <Tr key={p.provider}>
                    <Td pl={6} verticalAlign="top">
                      <Text fontWeight="600">{p.provider}</Text>
                      <Text fontSize="xs" color="gray.500">{p.service}</Text>
                    </Td>
                    <Td whiteSpace="normal" minW="220px" fontSize="13px" color="gray.700" verticalAlign="top">
                      <Text>{p.use}</Text>
                      {p.relevance === 'Crítica' && <Tag bg="red.50" color="red.700">Crítica</Tag>}
                    </Td>
                    <Td pr={6} fontSize="13px" verticalAlign="top">
                      <Link href={`https://${p.portal}`} isExternal color="purple.700" display="inline-flex" alignItems="center" gap={1}>{p.portal} <FiExternalLink /></Link>
                      <Text color="gray.600">Entra con {p.loginEmail || 'sin dato'}{p.username && p.username !== p.loginEmail ? ` (usuario ${p.username})` : ''}</Text>
                      <Text color="gray.500">Factura a {p.invoiceEmail || 'sin dato'}</Text>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose}>Cerrar</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
